const SITE_SEARCH_STATE = {
  EMPTY: 0,
  NO_RESULT: 1,
  LOADING: 2,
  WITH_RESULT: 3,
};

class SiteSearch {
  constructor(el) {
    this.endpoint = window.ddb.api.search.url;
    this.newsToken = window.ddb.api.search.token;
    this.action = window.ddb.api.search.action;

    this.$el = $(el);
    this.el = el;
    this.$form = this.$el.find('.site-search-form');
    this.$input = this.$form.find('.input-control');
    this.$popular = this.$el.find('.site-search-popular');
    this.$result = this.$el.find('.site-search-result');
    this.$resultList = this.$el.find('.site-search-result__list');
    this.$alert = this.$el.find('.site-search-result__alert');
    this.$loadmoreBtn = this.$el.find('.button');
    this.$loading = this.$el.find('.site-search-result__loading');

    this.page = 1;
    this._keyword = '';
    this._state = SITE_SEARCH_STATE.EMPTY;
    this._loading = false;

    this.$input.on('change', SiteSearch.prototype.onInputChange.bind(this));
    this.$loadmoreBtn.on('click', SiteSearch.prototype.onClickLoadmore.bind(this));
    this.$popular.find('.site-search-popular__item a').on('click', SiteSearch.prototype.onClickPopularSearchItem.bind(this));

    this.$loading.css({
      'display': 'none',
      'text-align': 'center'
    });

    this.$loadmoreBtn.hide();
  }

  onInputChange(e) {
    const keyword = this.$input.val();

    if (keyword.length >= 3) {
      this.showLoading();
      this.showSearchResult();
      this._search(keyword);
    } else {
      this.showPopularSearch()
    }
  }

  onClickLoadmore(e) {
    if (this._isLoading) return;

    this.page += 1;
    this.setLoadmoreLoading(true)
    this._search(this._keyword);
  }

  onClickPopularSearchItem(e) {
    const keyword = e.currentTarget.innerText
    this.$input.val(keyword).triggerHandler('change');
  }

  async _search(keyword) {
    this._keyword = keyword;
    const httpRequest = await this.search(this._keyword);
    this.$loading.hide();

    let result = httpRequest.data;
    if (!result.data)
      return;

    if (result.data.list && result.data.list.length > 0) {
      let html = '';
      result.data.list.forEach((item) => {
        html += this.generateHTMLItem(item);
      })
      this.$resultList.append(html)
      if (result.data.pagination){
        this.loadMore(result.data.pagination)
      }

      if (this._isLoading)
       this.setLoadmoreLoading(false)

    } else {
      this.$alert.html(this.generateAlertMessage())
    }

  }

  generateHTMLItem(data) {
    return `
            <div class="site-search-result__item" data-url="${data.link}">
               <div class="site-search-result__item__preview">
                 <div class="image-cover " style="background-image: url(${data.image}); "></div>
               </div>
               <div class="site-search-result__item__content">
                 <span class="site-search-result__item__tag">${data.post_type}</span>
                 <a href="${data.link}" class="site-search-result__item__title">${this.limitTitle(data.title)}</a>
               </div>
            </div>
    `;
  }

  generateAlertMessage() {
    return `
           <span>Sorry we couldn't find any results matching "${this._keyword}"</span>
    `;
  }

  populateSearchResult(result) {
    if (result.length == 0) {
      // @TODO: show error
    } else {
      // @TODO: generate result + pagination
    }
  }

  loadMore(pagination) {
    if (pagination.page < pagination.total_page ){
      this.$loadmoreBtn.show()
    } else {
      this.$loadmoreBtn.hide()
    }
  }

  setLoadmoreLoading(state) {
    this._isLoading = !!state;
    this.$loadmoreBtn.buttonloader('loading', !!state);
  }

  showLoading() {
    this.page = 1;
    this.$alert.html('')
    this.$resultList.html('')
    this.$loadmoreBtn.hide()
    this.$loading.show();
  }

  limitTitle(str) {
    if(str.length > 20)
      str = str.substring(0,20) + '...';
    return str;
  }

  showPopularSearch() {
    this.$popular.css({display: 'block'});
    this.$result.css({display: 'none'});
  }

  showSearchResult() {
    this.$result.css({display: 'block'});
    this.$popular.css({display: 'none'});
  }

  async search(query) {
    return axios.get(this.endpoint, {
      params: {
        page: this.page,
        s: query
      }
    });
  }
}

module.exports = SiteSearch;

